// import Rellax from './../../../../../../node_modules/rellax'
import lax from 'lax.js'
export default () => {
	// const 420 = 420; // Screen width < 420
	// const 1140 = 1440; // Screen width > 420
	lax.init()
	lax.addDriver('scrollY', function () {
		return window.scrollY
	})
	lax.addElements('.rellax img', {
		scrollY: {
			translateY: [
				["elInY", "elCenterY", "elOutY"],
				{
					420: [50, 0, -50],
					1140: [50, 0, -50]
				},
			]
		}
	})
	lax.addElements('.rellax svg', {
		scrollY: {
			translateY: [
				["elInY", "elCenterY", "elOutY"],
				{
					420: [60, 0, -100],
					1140: [60, 0, -100]
				},
				
			]
		}
	})
	lax.addElements('.shadow-wrapper img', {
		scrollY: {
			translateY: [
				["elInY", "elCenterY", "elOutY"],
				{
					420: [50, 0, -50],
					1140: [50, 0, -50]
				},
			]
		}
	})
	lax.addElements('.shadow-wrapper .shadow-circle', {
		scrollY: {
			translateY: [
				["elInY", "elCenterY", "elOutY"],
				{
					420: [0, 0, -15],
					1140: [-15, 0, 30]
				},
			]
		}
	})
	// const rellaxed = document.querySelectorAll('.rellax')
	// if (rellaxed.length > 0) {
	// 	const rellax = new Rellax('.rellax', {
	// 		center: true
	//     })
	// }
} 